import { render } from "./Unit2-2.vue?vue&type=template&id=6342f938&scoped=true"
import script from "./Unit2-2.vue?vue&type=script&lang=js"
export * from "./Unit2-2.vue?vue&type=script&lang=js"

import "../assets/css/common.css?vue&type=style&index=0&lang=css"
import "../assets/css/Unit2-2.css?vue&type=style&index=1&id=6342f938&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6342f938"]])

export default __exports__